{
  "nav": "Alertes",
  "navOpen_one": "{{count}} alerte ouverte",
  "navOpen_other": "{{count}} alertes ouvertes",
  "navOpenMany": "Plus de {{count}} alertes ouvertes",
  "title": "Alertes",
  "description": "Ce que vos règles ont constaté. Prenez en compte une alerte pour dire que vous l’avez vue, mettez-la en veille pour l’écarter un moment, résolvez-la quand le problème est réglé.",
  "filter": {
    "label": "Filtrer par état",
    "open": "Ouvertes",
    "acknowledged": "Prises en compte",
    "snoozed": "En veille",
    "resolved": "Résolues",
    "all": "Toutes"
  },
  "status": {
    "open": "Ouverte",
    "acknowledged": "Prise en compte",
    "snoozed": "En veille",
    "snoozedUntil": "En veille jusqu’à {{time}}",
    "resolved": "Résolue"
  },
  "loading": "Chargement des alertes…",
  "error": "Impossible de charger les alertes. Elles réapparaîtront dès que le serveur répondra.",
  "empty": {
    "open": "Aucune alerte ouverte. Une alerte apparaît ici quand une règle constate quelque chose.",
    "other": "Aucune alerte dans cet état.",
    "rules": "Voir les règles"
  },
  "deletedRule": "Règle supprimée",
  "unknownSource": "Source inconnue",
  "fireCount": "×{{count}}",
  "fireCountLabel_one": "{{count}} déclenchement",
  "fireCountLabel_other": "{{count}} déclenchements",
  "openedAgo": "ouverte {{ago}}",
  "updated": "Mis à jour à {{time}}",
  "actions": {
    "label": "Actions sur {{title}}",
    "ack": "Prendre en compte",
    "snooze": "Mettre en veille",
    "snoozeDurations": "Durée de la veille",
    "snoozeFor": "Mettre en veille {{duration}}",
    "resolve": "Résoudre",
    "failed": "L’action a échoué.",
    "conflict": "Cette alerte est déjà résolue."
  },
  "select": {
    "one": "Sélectionner {{title}}",
    "all": "Tout sélectionner",
    "count_one": "{{count}} sélectionnée",
    "count_other": "{{count}} sélectionnées",
    "ack": "Tout prendre en compte ({{count}})",
    "pending": "Prise en compte…",
    "clear": "Effacer la sélection",
    "done_one": "{{count}} alerte prise en compte.",
    "done_other": "{{count}} alertes prises en compte.",
    "failed": "La prise en compte groupée a échoué."
  },
  "loadMore": "Charger plus",
  "loadingMore": "Chargement…",
  "noisy": {
    "title": "Règles les plus bruyantes (7 j)",
    "description": "Une règle qui se déclenche souvent mérite peut-être un seuil plus haut ou un délai plus long.",
    "fires_one": "{{count}} déclenchement",
    "fires_other": "{{count}} déclenchements",
    "alerts_one": "{{count}} alerte",
    "alerts_other": "{{count}} alertes",
    "window": "Du {{from}} au {{to}}",
    "link": "Ajuster les règles",
    "error": "Classement indisponible pour l’instant."
  },
  "detail": {
    "close": "Fermer",
    "loading": "Chargement de l’historique…",
    "error": "Impossible de charger l’historique de cette alerte.",
    "severity": "Gravité",
    "opened": "Ouverte",
    "lastFired": "Dernier déclenchement",
    "fires": "Déclenchements",
    "acked": "Prise en compte",
    "snoozedUntil": "En veille jusqu’à",
    "resolved": "Résolue",
    "context": "Contexte transmis",
    "contextEmpty": "Aucun contexte transmis.",
    "timeline": "Historique",
    "timelineEmpty": "Aucune transition enregistrée."
  },
  "transitions": {
    "opened": "Ouverte",
    "fired": "Nouveau déclenchement",
    "acknowledged": "Prise en compte",
    "snoozed": "Mise en veille",
    "resolved": "Résolue",
    "notified": "Notification envoyée",
    "throttled": "Règle mise en pause",
    "unsnoozed": "Fin de la veille",
    "notifiedSilenced": "Notification retenue",
    "delivery_failed": "Échec d’envoi"
  },
  "notify": {
    "reason": "motif",
    "reasons": {
      "opened": "nouvelle alerte",
      "fired": "nouveau déclenchement",
      "unsnoozed": "fin de la veille"
    },
    "delivered": "envoyée",
    "none": "aucun canal",
    "suppressed": {
      "quiet_hours": "retenu : heures calmes",
      "not_configured": "retenu : non configuré"
    },
    "channel": "canal",
    "attempts": "tentatives",
    "error": "erreur"
  },
  "reasons": {
    "manual": "à la main",
    "cleared": "condition levée",
    "idle": "plus d’événement correspondant",
    "rule_deleted": "règle supprimée"
  }
}
